module.exports = __webpack_public_path__ + "static/preview5-9b6419ea79ab36c9f05ed144f1d51b55.png";